<script lang="ts">
  /**
   * <Toast /> - the proto's single ink pill above the bottom nav.
   * Mount once inside the phone frame (AppShell). Use `toast.show(...)`
   * from anywhere to enqueue.
   */
  import { fly, fade } from 'svelte/transition';
  import { toast } from '../lib/toast.svelte';
</script>

<div class="toast-host" role="status" aria-live="polite" aria-atomic="false">
  {#each toast.items as t (t.id)}
    <button
      type="button"
      class="toast"
      onclick={() => toast.dismiss(t.id)}
      aria-label={`Sulje ilmoitus: ${t.message}`}
      in:fly={{ y: 20, duration: 250 }}
      out:fade={{ duration: 200 }}
    >
      {t.message}
    </button>
  {/each}
</div>

<style>
  .toast-host {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 84px;
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 0 16px;
    pointer-events: none;
  }
  @media (max-width: 639px) {
    .toast-host {
      position: fixed;
      bottom: calc(84px + env(safe-area-inset-bottom, 0px));
    }
  }
  .toast {
    pointer-events: auto;
    max-width: 100%;
    padding: 10px 16px;
    border-radius: 999px;
    background: var(--viisi-ink);
    color: var(--viisi-ground);
    font-weight: 600;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-shadow: var(--viisi-shadow);
  }
</style>
